import { Product } from '../types';

// ============================================
// SPECIAL UNIVERSAL CONNECTORS - HIGH POLE COUNT (7-34 POLE)
// ============================================

// 7-11 POLE SPECIAL CONNECTORS
export const specialConnectorHighPoleSmallProducts: Product[] = [
  {
    id: "special-conn-tata-rear-wire-7p-f",
    name: "Tata Rear Wire 7 Pole Female",
    slug: "special-tata-rear-wire-7-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata rear wire 7 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100761",
    image: "/products/special-universal-connectors/special-universal/SH2100761.jpg",
    specifications: {
      "Poles": "7 Pole",
      "Gender": "Female",
      "Compatible": "Tata Rear Wire",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "7-pole", "tata", "rear-wire", "female"],
    applications: ["Tata Rear Wire"],
  },
  {
    id: "special-conn-al-7p-m-4mm",
    name: "Ashok Leyland 7 Pole Male - 4mm Wire",
    slug: "special-al-7-pole-male-4mm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland 7 pole male connector with 4mm deluxe wire.",
    partNumber: "SH2100771",
    image: "/products/special-universal-connectors/special-universal/SH2100771.jpg",
    specifications: {
      "Poles": "7 Pole",
      "Gender": "Male",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "7-pole", "ashok-leyland", "male"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-tata-air-filter-8p-f",
    name: "Tata Air Filter 8 Pole Female",
    slug: "special-tata-air-filter-8-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata air filter 8 pole female connector with special wire.",
    partNumber: "SH2100781",
    image: "/products/special-universal-connectors/special-universal/SH2100781.jpg",
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Female",
      "Compatible": "Tata Air Filter",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "8-pole", "tata", "air-filter", "female"],
    applications: ["Tata Air Filter"],
  },
  {
    id: "special-conn-al-7p-f-4mm",
    name: "Ashok Leyland 7 Pole Female - 4mm Wire",
    slug: "special-al-7-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland 7 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100791",
    image: "/products/special-universal-connectors/special-universal/SH2100791.jpg",
    specifications: {
      "Poles": "7 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "7-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-8p-ecm",
    name: "Universal 8 Pole - ECM Wire",
    slug: "special-universal-8-pole-ecm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal 8 pole connector with ECM wire.",
    partNumber: "SH2100851",
    image: "/products/special-universal-connectors/special-universal/SH2100851.jpg",
    specifications: {
      "Poles": "8 Pole",
      "Wire Type": "ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "8-pole", "universal", "ecm"],
    applications: ["Universal Applications", "ECM"],
  },
  {
    id: "special-conn-al-8p-f-ecm",
    name: "Ashok Leyland 8 Pole Female - ECM Wire",
    slug: "special-al-8-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland 8 pole female connector with ECM wire.",
    partNumber: "SH2100853",
    image: "/products/special-universal-connectors/special-universal/SH2100853.jpg",
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "8-pole", "ashok-leyland", "ecm", "female"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "special-conn-al-8-3p-f-4-5mm",
    name: "Ashok Leyland 8+3 Pole Female - 4mm & 5mm Wire",
    slug: "special-al-8-3-pole-female-4-5mm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland 8+3 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH2100854",
    image: "/products/special-universal-connectors/special-universal/SH2100854.jpg",
    specifications: {
      "Poles": "8+3 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "8-3-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-7p-f-ecm",
    name: "Universal 7 Pole Female - ECM Special Wire",
    slug: "special-universal-7-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal 7 pole female connector with ECM special wire.",
    partNumber: "SH2100911",
    image: "/products/special-universal-connectors/special-universal/SH2100911.jpg",
    specifications: {
      "Poles": "7 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "7-pole", "universal", "ecm", "female"],
    applications: ["Universal Applications", "ECM"],
  },
  {
    id: "special-conn-combination-switch-scorpio-9p-f",
    name: "Combination Switch-I Scorpio 9 Pole Female",
    slug: "special-combination-switch-scorpio-9-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Combination switch-I for Scorpio 9 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2101091",
    image: "/products/special-universal-connectors/special-universal/SH2101091.jpg",
    featured: true,
    specifications: {
      "Poles": "9 Pole",
      "Gender": "Female",
      "Compatible": "Scorpio Combination Switch-I",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "9-pole", "scorpio", "combination-switch", "female"],
    applications: ["Mahindra Scorpio", "Combination Switch"],
  },
  {
    id: "special-conn-al-10p-f-5mm",
    name: "Ashok Leyland 10 Pole Female - 5mm Wire",
    slug: "special-al-10-pole-female-5mm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland 10 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2101094",
    image: "/products/special-universal-connectors/special-universal/SH2101094.jpg",
    specifications: {
      "Poles": "10 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "10-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-tata-ecm-10p-f",
    name: "Tata ECM 10 Pole Female",
    slug: "special-tata-ecm-10-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata ECM 10 pole female connector with ECM special wire.",
    partNumber: "SH2101098",
    image: "/products/special-universal-connectors/special-universal/SH2101098.jpg",
    featured: true,
    specifications: {
      "Poles": "10 Pole",
      "Gender": "Female",
      "Compatible": "Tata ECM",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "10-pole", "tata", "ecm", "female"],
    applications: ["Tata ECM", "Engine Control"],
  },
  {
    id: "special-conn-universal-relay-base-tata-10p-f",
    name: "Universal Relay Base Tata 10 Pole Female - 4mm & 5mm Wire",
    slug: "special-universal-relay-base-tata-10-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal relay base for Tata 10 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH2101154",
    image: "/products/special-universal-connectors/special-universal/SH2101154.jpg",
    specifications: {
      "Poles": "10 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "10-pole", "universal", "tata", "relay-base", "female"],
    applications: ["Tata Relay Base"],
  },
];

// 12-13 POLE SPECIAL CONNECTORS
export const specialConnector12_13PoleProducts: Product[] = [
  {
    id: "special-conn-al-new-model-12p-f-ecm",
    name: "Ashok Leyland New Model 12 Pole Female - ECM Special Wire",
    slug: "special-al-new-model-12-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland new model 12 pole female connector with ECM special wire.",
    partNumber: "SH2101201",
    image: "/products/special-universal-connectors/special-universal/SH2101201.jpg",
    featured: true,
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "12-pole", "ashok-leyland", "new-model", "ecm", "female"],
    applications: ["Ashok Leyland New Model", "ECM"],
  },
  {
    id: "special-conn-al-12p-f-4mm",
    name: "Ashok Leyland 12 Pole Female - 4mm Wire",
    slug: "special-al-12-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland 12 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2101211",
    image: "/products/special-universal-connectors/special-universal/SH2101211.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "12-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-maruti-car-van-12p-f-1",
    name: "Maruti Car/Van 12 Pole Female - Special Wire",
    slug: "special-maruti-car-van-12-pole-female-1",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Maruti car/van 12 pole female connector with special wire.",
    partNumber: "SH2101253",
    image: "/products/special-universal-connectors/special-universal/SH2101253.jpg",
    featured: true,
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "Maruti Car, Van",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "12-pole", "maruti", "car", "van", "female"],
    applications: ["Maruti Car", "Maruti Van"],
  },
  {
    id: "special-conn-universal-12p-f-special",
    name: "Universal 12 Pole Female - Special Wire",
    slug: "special-universal-12-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal 12 pole female connector with special wire.",
    partNumber: "SH2101261",
    image: "/products/special-universal-connectors/special-universal/SH2101261.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "12-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-maruti-car-van-12p-f-2",
    name: "Maruti Car/Van 12 Pole Female - Special Wire (Type 2)",
    slug: "special-maruti-car-van-12-pole-female-2",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Maruti car/van 12 pole female connector with special wire.",
    partNumber: "SH2101263",
    image: "/products/special-universal-connectors/special-universal/SH2101263.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "Maruti Car, Van",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "12-pole", "maruti", "car", "van", "female"],
    applications: ["Maruti Car", "Maruti Van"],
  },
  {
    id: "special-conn-al-12p-f-4mm-2",
    name: "Ashok Leyland 12 Pole Female - 4mm Wire (Type 2)",
    slug: "special-al-12-pole-female-4mm-2",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland 12 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2101265",
    image: "/products/special-universal-connectors/special-universal/SH2101265.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "12-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-maruti-car-van-13p-f",
    name: "Maruti Car/Van 13 Pole Female - Special & 4mm Wire",
    slug: "special-maruti-car-van-13-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Maruti car/van 13 pole female connector with special & 4mm deluxe wire.",
    partNumber: "SH2101311",
    image: "/products/special-universal-connectors/special-universal/SH2101311.jpg",
    specifications: {
      "Poles": "13 Pole",
      "Gender": "Female",
      "Compatible": "Maruti Car, Van",
      "Wire Type": "Special & 4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "13-pole", "maruti", "car", "van", "female"],
    applications: ["Maruti Car", "Maruti Van"],
  },
  {
    id: "special-conn-pwr-window-switch-accent-13p-f",
    name: "PWR Window Switch Accent/Maruti Combination Switch 13 Pole Female",
    slug: "special-pwr-window-switch-accent-maruti-13-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Power window switch for Accent/Maruti combination switch 13 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2101355",
    image: "/products/special-universal-connectors/special-universal/SH2101355.jpg",
    specifications: {
      "Poles": "13 Pole",
      "Gender": "Female",
      "Compatible": "Accent PWR Window Switch, Maruti Combination Switch",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "13-pole", "accent", "maruti", "power-window", "combination-switch", "female"],
    applications: ["Hyundai Accent", "Maruti", "Power Window Switch"],
  },
];

// 15-16 POLE SPECIAL CONNECTORS
export const specialConnector15_16PoleProducts: Product[] = [
  {
    id: "special-conn-universal-tata-15p-f",
    name: "Universal Tata 15 Pole Female",
    slug: "special-universal-tata-15-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal Tata 15 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2101510",
    image: "/products/special-universal-connectors/special-universal/SH2101510.jpg",
    specifications: {
      "Poles": "15 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "15-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-tata-16p-f-special-1",
    name: "Universal Tata 16 Pole Female - Special Wire",
    slug: "special-universal-tata-16-pole-female-special-1",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal Tata 16 pole female connector with special wire.",
    partNumber: "SH2101655",
    image: "/products/special-universal-connectors/special-universal/SH2101655.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-al-universal-maruti-ecm-16p-f",
    name: "Ashok Leyland/Universal Maruti ECM 16 Pole Female",
    slug: "special-al-universal-maruti-ecm-16-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland/Universal Maruti ECM 16 pole female connector with special wire.",
    partNumber: "SH2101657",
    image: "/products/special-universal-connectors/special-universal/SH2101657.jpg",
    featured: true,
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland, Universal Maruti ECM",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "ashok-leyland", "maruti", "ecm", "female"],
    applications: ["Ashok Leyland", "Maruti ECM", "Engine Control"],
  },
  {
    id: "special-conn-tata-new-model-16p-f-1",
    name: "Tata New Model 16 Pole Female - Special Wire",
    slug: "special-tata-new-model-16-pole-female-1",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata new model 16 pole female connector with special wire.",
    partNumber: "SH2101659",
    image: "/products/special-universal-connectors/special-universal/SH2101659.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Tata New Model",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "tata", "new-model", "female"],
    applications: ["Tata New Model"],
  },
  {
    id: "special-conn-universal-tata-16p-f-special-2",
    name: "Universal Tata 16 Pole Female - Special Wire (Type 2)",
    slug: "special-universal-tata-16-pole-female-special-2",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal Tata 16 pole female connector with special wire.",
    partNumber: "SH2101662",
    image: "/products/special-universal-connectors/special-universal/SH2101662.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-tata-new-model-16p-f-2",
    name: "Tata New Model 16 Pole Female - Special Wire (Type 2)",
    slug: "special-tata-new-model-16-pole-female-2",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata new model 16 pole female connector with special wire.",
    partNumber: "SH2101664",
    image: "/products/special-universal-connectors/special-universal/SH2101664.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Tata New Model",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "tata", "new-model", "female"],
    applications: ["Tata New Model"],
  },
  {
    id: "special-conn-al-new-model-16p-f-special",
    name: "Ashok Leyland New Model 16 Pole Female - Special Wire",
    slug: "special-al-new-model-16-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland new model 16 pole female connector with special wire.",
    partNumber: "SH2101667",
    image: "/products/special-universal-connectors/special-universal/SH2101667.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-conn-universal-tata-16p-f-special-3",
    name: "Universal Tata 16 Pole Female - Special Wire (Type 3)",
    slug: "special-universal-tata-16-pole-female-special-3",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal Tata 16 pole female connector with special wire.",
    partNumber: "SH2101670",
    image: "/products/special-universal-connectors/special-universal/SH2101670.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-16p-f-ecm",
    name: "Universal 16 Pole Female - ECM Special Wire",
    slug: "special-universal-16-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal 16 pole female connector with ECM special wire.",
    partNumber: "SH2101671",
    image: "/products/special-universal-connectors/special-universal/SH2101671.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "universal", "ecm", "female"],
    applications: ["Universal Applications", "ECM"],
  },
  {
    id: "special-conn-al-tata-new-model-16p-f-ecm-1",
    name: "Ashok Leyland & Tata New Model 16 Pole Female - ECM",
    slug: "special-al-tata-new-model-16-pole-female-ecm-1",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland & Tata new model 16 pole female connector with ECM special wire.",
    partNumber: "SH2101673",
    image: "/products/special-universal-connectors/special-universal/SH2101673.jpg",
    featured: true,
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata New Model",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "ashok-leyland", "tata", "new-model", "ecm", "female"],
    applications: ["Ashok Leyland New Model", "Tata New Model", "ECM"],
  },
  {
    id: "special-conn-al-tata-new-model-16p-f-ecm-2",
    name: "Ashok Leyland & Tata New Model 16 Pole Female - ECM (Type 2)",
    slug: "special-al-tata-new-model-16-pole-female-ecm-2",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland & Tata new model 16 pole female connector with ECM special wire.",
    partNumber: "SH2101674",
    image: "/products/special-universal-connectors/special-universal/SH2101674.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata New Model",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "ashok-leyland", "tata", "new-model", "ecm", "female"],
    applications: ["Ashok Leyland New Model", "Tata New Model", "ECM"],
  },
  {
    id: "special-conn-tata-ace-cng-16p-f",
    name: "Tata ACE CNG 16 Pole Female",
    slug: "special-tata-ace-cng-16-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata ACE CNG 16 pole female connector with special wire.",
    partNumber: "SH2101675",
    image: "/products/special-universal-connectors/special-universal/SH2101675.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Tata ACE CNG",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-pole", "tata", "ace", "cng", "female"],
    applications: ["Tata ACE CNG"],
  },
];

// 18-20 POLE SPECIAL CONNECTORS
export const specialConnector18_20PoleProducts: Product[] = [
  {
    id: "special-conn-tata-ecm-18p-f",
    name: "Tata ECM 18 Pole Female",
    slug: "special-tata-ecm-18-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata ECM 18 pole female connector with ECM special wire.",
    partNumber: "SH2101811",
    image: "/products/special-universal-connectors/special-universal/SH2101811.jpg",
    featured: true,
    specifications: {
      "Poles": "18 Pole",
      "Gender": "Female",
      "Compatible": "Tata ECM",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "18-pole", "tata", "ecm", "female"],
    applications: ["Tata ECM", "Engine Control"],
  },
  {
    id: "special-conn-al-18p-f-ecm",
    name: "Ashok Leyland 18 Pole Female - ECM Special Wire",
    slug: "special-al-18-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland 18 pole female connector with ECM special wire.",
    partNumber: "SH2101826",
    image: "/products/special-universal-connectors/special-universal/SH2101826.jpg",
    specifications: {
      "Poles": "18 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "18-pole", "ashok-leyland", "ecm", "female"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "special-conn-universal-18p-f-special",
    name: "Universal 18 Pole Female - Special Wire",
    slug: "special-universal-18-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal 18 pole female connector with special wire.",
    partNumber: "SH2101855",
    image: "/products/special-universal-connectors/special-universal/SH2101855.jpg",
    specifications: {
      "Poles": "18 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "18-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-universal-20p-f-special",
    name: "Universal 20 Pole Female - Special Wire",
    slug: "special-universal-20-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal 20 pole female connector with special wire.",
    partNumber: "SH2102055",
    image: "/products/special-universal-connectors/special-universal/SH2102055.jpg",
    specifications: {
      "Poles": "20 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "20-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-tata-16-4p-f",
    name: "Tata 16+4 Pole Female - 4mm & 5mm Wire",
    slug: "special-tata-16-4-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata 16+4 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH2102057",
    image: "/products/special-universal-connectors/special-universal/SH2102057.jpg",
    featured: true,
    specifications: {
      "Poles": "16+4 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-4-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-tata-16-4p-m",
    name: "Tata 16+4 Pole Male - 4mm & 5mm Wire",
    slug: "special-tata-16-4-pole-male",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata 16+4 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH2102061",
    image: "/products/special-universal-connectors/special-universal/SH2102061.jpg",
    featured: true,
    specifications: {
      "Poles": "16+4 Pole",
      "Gender": "Male",
      "Compatible": "Tata",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "16-4-pole", "tata", "male"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-tata-20p-f-special",
    name: "Universal Tata 20 Pole Female - Special Wire",
    slug: "special-universal-tata-20-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Universal Tata 20 pole female connector with special wire.",
    partNumber: "SH2102062",
    image: "/products/special-universal-connectors/special-universal/SH2102062.jpg",
    specifications: {
      "Poles": "20 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "20-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-tata-filter-20p-f-ecm",
    name: "Tata Filter 20 Pole Female - ECM Special Wire",
    slug: "special-tata-filter-20-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata filter 20 pole female connector with ECM special wire.",
    partNumber: "SH2102063",
    image: "/products/special-universal-connectors/special-universal/SH2102063.jpg",
    specifications: {
      "Poles": "20 Pole",
      "Gender": "Female",
      "Compatible": "Tata Filter",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "20-pole", "tata", "filter", "ecm", "female"],
    applications: ["Tata Filter", "ECM"],
  },
  {
    id: "special-conn-tata-20p-f-ecm",
    name: "Tata 20 Pole Female - ECM Special Wire",
    slug: "special-tata-20-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata 20 pole female connector with ECM special wire.",
    partNumber: "SH2102064",
    image: "/products/special-universal-connectors/special-universal/SH2102064.jpg",
    specifications: {
      "Poles": "20 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "20-pole", "tata", "ecm", "female"],
    applications: ["Tata", "ECM"],
  },
  {
    id: "special-conn-tata-20p-f-ecm-2",
    name: "Tata 20 Pole Female - ECM Special Wire (Type 2)",
    slug: "special-tata-20-pole-female-ecm-2",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata 20 pole female connector with ECM special wire.",
    partNumber: "SH2102066",
    image: "/products/special-universal-connectors/special-universal/SH2102066.jpg",
    specifications: {
      "Poles": "20 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "20-pole", "tata", "ecm", "female"],
    applications: ["Tata", "ECM"],
  },
  {
    id: "special-conn-tata-20p-f-ecm-3",
    name: "Tata 20 Pole Female - ECM Special Wire (Type 3)",
    slug: "special-tata-20-pole-female-ecm-3",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata 20 pole female connector with ECM special wire.",
    partNumber: "SH2102068",
    image: "/products/special-universal-connectors/special-universal/SH2102068.jpg",
    specifications: {
      "Poles": "20 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "20-pole", "tata", "ecm", "female"],
    applications: ["Tata", "ECM"],
  },
];

// 22-26 POLE SPECIAL CONNECTORS
export const specialConnector22_26PoleProducts: Product[] = [
  {
    id: "special-conn-al-new-model-26p-f",
    name: "Ashok Leyland New Model 26 Pole Female",
    slug: "special-al-new-model-26-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland new model 26 pole female connector with ECM wire & 4mm deluxe wire.",
    partNumber: "SH2102601",
    image: "/products/ecm-connectors/ecm/SH2102601.jpg",
    featured: true,
    specifications: {
      "Poles": "26 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "ECM Wire & 4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "26-pole", "ashok-leyland", "new-model", "ecm", "female"],
    applications: ["Ashok Leyland New Model", "ECM"],
  },
  {
    id: "special-conn-al-new-model-26p-m",
    name: "Ashok Leyland New Model 26 Pole Male",
    slug: "special-al-new-model-26-pole-male",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland new model 26 pole male connector with ECM wire & 4mm deluxe wire.",
    partNumber: "SH2102602",
    image: "/products/ecm-connectors/ecm/SH2102602.jpg",
    featured: true,
    specifications: {
      "Poles": "26 Pole",
      "Gender": "Male",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "ECM Wire & 4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "26-pole", "ashok-leyland", "new-model", "ecm", "male"],
    applications: ["Ashok Leyland New Model", "ECM"],
  },
];

// 30-34 POLE SPECIAL CONNECTORS
export const specialConnector30_34PoleProducts: Product[] = [
  {
    id: "special-conn-tata-ace-32p-f-ecm-15in",
    name: "Tata Ace 32 Pole Female - ECM Special Wire (15\" Long)",
    slug: "special-tata-ace-32-pole-female-ecm-15in",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata Ace 32 pole female connector with ECM special & 5mm deluxe wire. 15 inch long.",
    partNumber: "SH2103229",
    image: "/products/ecm-connectors/ecm/SH2103229.jpg",
    featured: true,
    specifications: {
      "Poles": "32 Pole",
      "Gender": "Female",
      "Compatible": "Tata Ace",
      "Wire Type": "ECM Special & 5mm Deluxe",
      "Wire Length": "15 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "32-pole", "tata", "ace", "ecm", "female", "long-wire"],
    applications: ["Tata Ace", "ECM"],
  },
  {
    id: "special-conn-tata-ace-cluster-32p-f-ecm-15in",
    name: "Cluster Tata Ace 32 Pole Female - ECM Special Wire (15\" Long)",
    slug: "special-cluster-tata-ace-32-pole-female-ecm-15in",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Cluster for Tata Ace 32 pole female connector with ECM special wire. 15 inch long.",
    partNumber: "SH2103230",
    image: "/products/ecm-connectors/ecm/SH2103230.jpg",
    specifications: {
      "Poles": "32 Pole",
      "Gender": "Female",
      "Compatible": "Tata Ace Cluster",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "15 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "32-pole", "tata", "ace", "cluster", "ecm", "female", "long-wire"],
    applications: ["Tata Ace Cluster", "ECM"],
  },
  {
    id: "special-conn-tata-magic-32p-f-ecm-15in",
    name: "Tata Magic 32 Pole Female - ECM Special Wire (15\" Long)",
    slug: "special-tata-magic-32-pole-female-ecm-15in",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Tata Magic 32 pole female connector with ECM special & 5mm deluxe wire. 15 inch long.",
    partNumber: "SH2103432",
    image: "/products/ecm-connectors/ecm/SH2103432.jpg",
    specifications: {
      "Poles": "32 Pole",
      "Gender": "Female",
      "Compatible": "Tata Magic",
      "Wire Type": "ECM Special & 5mm Deluxe",
      "Wire Length": "15 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "32-pole", "tata", "magic", "ecm", "female", "long-wire"],
    applications: ["Tata Magic", "ECM"],
  },
  {
    id: "special-conn-al-tata-34p-f-ecm-15in",
    name: "Ashok Leyland & Tata 34 Pole Female - ECM (15\" Long)",
    slug: "special-al-tata-34-pole-female-ecm-15in",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland & Tata 34 pole female connector with ECM special, 5mm & 8mm deluxe wire. 15 inch long.",
    partNumber: "SH2103433",
    image: "/products/ecm-connectors/ecm/SH2103433.jpg",
    featured: true,
    specifications: {
      "Poles": "34 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "ECM Special, 5mm & 8mm Deluxe",
      "Wire Length": "15 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "34-pole", "ashok-leyland", "tata", "ecm", "female", "long-wire"],
    applications: ["Ashok Leyland", "Tata", "ECM"],
  },
  {
    id: "special-conn-al-tata-34p-m-ecm-15in",
    name: "Ashok Leyland & Tata 34 Pole Male - ECM (15\" Long)",
    slug: "special-al-tata-34-pole-male-ecm-15in",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland & Tata 34 pole male connector with ECM special, 5mm & 8mm deluxe wire. 15 inch long.",
    partNumber: "SH2103401",
    image: "/products/special-universal-connectors/special-universal/SH2103401.jpg",
    featured: true,
    specifications: {
      "Poles": "34 Pole",
      "Gender": "Male",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "ECM Special, 5mm & 8mm Deluxe",
      "Wire Length": "15 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "34-pole", "ashok-leyland", "tata", "ecm", "male", "long-wire"],
    applications: ["Ashok Leyland", "Tata", "ECM"],
  },
  {
    id: "special-conn-al-bs4-air-sensor-34p-f",
    name: "Ashok Leyland BS-IV Air Sensor & Pressure Hub 34 Pole Female",
    slug: "special-al-bs4-air-sensor-34-pole-female",
    category: "Special Universal Connectors",
    subcategory: "High Pole Connectors",
    description: "Ashok Leyland BS-IV air sensor & pressure hub 34 pole female connector with 4mm deluxe & special wire.",
    partNumber: "SH2103402",
    image: "/products/special-universal-connectors/special-universal/SH2103402.jpg",
    featured: true,
    specifications: {
      "Poles": "34 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland BS-IV Air Sensor & Pressure Hub",
      "Wire Type": "4mm Deluxe & Special Wire",
      "Wire Length": "9 inches",
      "Standards": "BS-IV",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "34-pole", "ashok-leyland", "bs4", "air-sensor", "pressure-hub", "female"],
    applications: ["Ashok Leyland BS-IV", "Air Sensor", "Pressure Hub"],
  },
];
